enum SalaryTimeSpan {
  PerAnnum = 'PerAnnum',
  PerMonth = 'PerMonth',
  PerDay = 'PerDay',
  PerHour = 'PerHour',
  None = 'None',
}

export default SalaryTimeSpan;
